import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication';

export const customerIdGuard: CanActivateFn = (route, state) => {
  if (Number(route.queryParamMap.get('customerId'))) return true;

  const router = inject(Router);
  const tokenCustomerId = inject(
    AuthenticationService
  ).getCustomerIdFromToken();
  if (!tokenCustomerId) return router.createUrlTree(['/customer-select']);

  const url = router.parseUrl(state.url);
  url.queryParams = { ...url.queryParams, customerId: tokenCustomerId };
  return new RedirectCommand(url, { replaceUrl: true });
};
